import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/request-password-reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({
          type: 'success',
          message: 'Falls die E-Mail-Adresse in unserem System existiert, haben wir einen Reset-Link gesendet. Bitte überprüfe dein Postfach.'
        });
        setEmail('');
      } else {
        setStatus({
          type: 'error',
          message: data.detail || 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.'
        });
      }
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'Verbindungsfehler. Bitte überprüfe deine Internetverbindung.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <div className="forgot-password-header">
            <h1>🔐 Passwort vergessen?</h1>
            <p>Kein Problem! Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.</p>
          </div>

          {status.message && (
            <div className={`status-message ${status.type}`}>
              {status.type === 'success' && <span className="status-icon">✅</span>}
              {status.type === 'error' && <span className="status-icon">❌</span>}
              {status.message}
            </div>
          )}

          <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="form-group">
              <label htmlFor="email">E-Mail-Adresse</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="deine@email.com"
                required
                disabled={isSubmitting}
              />
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sende...' : 'Reset-Link senden'}
            </button>
          </form>

          <div className="forgot-password-footer">
            <Link to="/login" className="back-link">
              ← Zurück zur Anmeldung
            </Link>
          </div>

          <div className="help-box">
            <h3>📧 E-Mail nicht erhalten?</h3>
            <ul>
              <li>Überprüfe deinen Spam-Ordner</li>
              <li>Stelle sicher, dass die E-Mail-Adresse korrekt ist</li>
              <li>Der Link ist 1 Stunde gültig</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
